const { documentElement, body } = document;

function _blockScroll(event) {
  event.preventDefault();
}

let LOCKED = false;

export default class ScrollLock {
  static lock() {
    if (LOCKED) {
      return;
    }

    LOCKED = true;
    documentElement.classList.add('scroll-locked');
    body.addEventListener('touchmove', _blockScroll, false);
    body.addEventListener('scroll', _blockScroll, false);
  }

  static unlock() {
    if (!LOCKED) {
      return;
    }

    LOCKED = false;
    documentElement.classList.remove('scroll-locked');
    body.removeEventListener('touchmove', _blockScroll, false);
    body.removeEventListener('scroll', _blockScroll, false);
  }
}
